/* tpl-ar-preview.js — AR / wall-preview controller for the product page.
   2026-10-01 (audit #4): moved out of sections/tpl-ar-preview.liquid, where it
   shipped as a 24 KB inline <script> on every product page and could not be
   cached. Copy strings now arrive on the root element as data attributes. */
    (function(){
    function bind(root){
      if (!root || root.dataset.bound) return;
      root.dataset.bound = '1';
      var base = root.dataset.base;
      var ver = root.dataset.ver || '1';
      var map = {};
      try { map = JSON.parse(root.querySelector('[data-ar-map]').textContent); } catch(e){}
      var modal = root.querySelector('.tpl-ar__modal');
      var mv = root.querySelector('model-viewer');
      var label = root.querySelector('[data-ar-variant]');
      var loaded = false;

      function form(){ return document.querySelector('form[action*="/cart/add"]'); }
      function currentId(){
        var f = form(); var i = f && f.querySelector('[name="id"]');
        return i ? i.value : null;
      }
      function entry(){ var id = currentId(); return id && map[id] ? map[id] : null; }
      // AR funnel telemetry: Shopify custom pixel bus + Clarity tag + dataLayer.
      // All three are optional at runtime; never let analytics break the UI.
      function track(stage){
        try {
          var path = root.dataset.productPath || location.pathname;
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
            Shopify.analytics.publish('tpl_ar_' + stage, { product: path, variant: currentId() });
          }
          if (typeof window.clarity === 'function') window.clarity('set', 'tpl_ar', stage);
          (window.dataLayer = window.dataLayer || []).push({ event: 'tpl_ar_' + stage, ar_product: path });
        } catch (e) {}
      }
      var atcBtn = root.querySelector('[data-ar-atc]');
      function pdpSubmit(){
        // Several forms share the /cart/add action (Dawn's installments form has
        // no submit button) so find the one that can actually submit.
        var fs = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < fs.length; i++) {
          var s = fs[i].querySelector('[type="submit"]');
          if (s) return s;
        }
        return null;
      }
      function syncAtc(){
        if (!atcBtn) return;
        var s = pdpSubmit();
        if (!s) { atcBtn.hidden = true; return; }
        atcBtn.hidden = false;
        atcBtn.disabled = !!s.disabled;
        var span = s.querySelector('span');
        var t = ((span ? span.textContent : s.textContent) || '').trim().split('\n')[0].trim();
        if (t) atcBtn.textContent = t;
      }
      if (atcBtn) atcBtn.addEventListener('click', function(){
        var s = pdpSubmit();
        if (!s || s.disabled) return;
        track('atc');
        close();
        s.click(); /* the real PDP submit: cart bridge + drawer take over */
      });
      var frameOpt = root.dataset.frameOption || '';
      var sizeOpt = root.dataset.sizeOption || '';
      // PDP option controls render as a <select> (dropdown picker) or as radio
      // pills depending on the template. Handle both.
      function getOpt(opt){
        if (!opt) return null;
        var sel = document.querySelector('select[name="options[' + opt + ']"]');
        if (sel) return sel.value;
        var r = document.querySelector('input[type="radio"][name="options[' + opt + ']"]:checked');
        return r ? r.value : null;
      }
      function setOpt(opt, v){
        if (!opt) return;
        var sel = document.querySelector('select[name="options[' + opt + ']"]');
        if (sel) {
          if (sel.value !== v) { sel.value = v; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          return;
        }
        var rs = document.querySelectorAll('input[type="radio"][name="options[' + opt + ']"]');
        for (var i = 0; i < rs.length; i++) {
          if (rs[i].value === v) {
            if (!rs[i].checked) { rs[i].checked = true; rs[i].dispatchEvent(new Event('change', { bubbles: true })); }
            return;
          }
        }
      }
      function setFrame(labelText){ setOpt(frameOpt, labelText); }
      function syncChips(){
        var fcur = getOpt(frameOpt);
        var scur = getOpt(sizeOpt);
        root.querySelectorAll('.tpl-ar__chip').forEach(function(c){
          if ('sizeLabel' in c.dataset) c.classList.toggle('is-active', c.dataset.sizeLabel === scur);
          else c.classList.toggle('is-active', c.dataset.frameLabel === fcur);
        });
        // Keep the active chip in view (rows scroll horizontally)
        root.querySelectorAll('.tpl-ar__chiprow').forEach(function(row){
          var act = row.querySelector('.is-active');
          if (!act) return;
          var rb = row.getBoundingClientRect();
          var ab = act.getBoundingClientRect();
          if (ab.left < rb.left + 8 || ab.right > rb.right - 8) {
            try { row.scrollTo({ left: act.offsetLeft - row.offsetLeft - 16, behavior: 'smooth' }); }
            catch (e) { row.scrollLeft = act.offsetLeft - row.offsetLeft - 16; }
          }
        });
      }
      var loadingEl = root.querySelector('[data-ar-loading]');
      function showLoading(){ if (loadingEl) loadingEl.classList.remove('hide'); }
      function hideLoading(){ if (loadingEl) loadingEl.classList.add('hide'); }
      function update(){
        var e = entry();
        if (!e) return;
        var src = base + '/' + e.file + '?v=' + ver;
        if (mv && mv.getAttribute('src') !== src) { showLoading(); mv.setAttribute('src', src); }
        if (label) {
          var parts = (e.label || '').split('/').map(function(s){ return s.trim(); });
          var sz = (parts[0] || '').replace(/\s*\(.*\)/, '').trim();
          label.textContent = [sz, parts[1] || ''].filter(Boolean).join(' · ');
        }
        syncChips();
        renderQR();
        syncWallArt();
        syncAtc();
        /* Dawn re-renders the buy button async after a variant change; re-read it */
        setTimeout(syncAtc, 650);
      }
      if (mv) mv.addEventListener('load', function(){
        hideLoading(); update();
        if (mv.canActivateAR === false) markNoAR();
      });
      // Failed GLB fetch (missing variant asset, network) — kill the infinite spinner.
      if (mv) mv.addEventListener('error', function(){
        hideLoading();
        var r = root.querySelector('.tpl-ar__rotate');
        if (r) r.textContent = 'Preview unavailable for this variant';
      });
      root.querySelectorAll('.tpl-ar__chip').forEach(function(c){
        c.addEventListener('click', function(){
          if ('sizeLabel' in c.dataset) setOpt(sizeOpt, c.dataset.sizeLabel);
          else setFrame(c.dataset.frameLabel);
        });
      });
      // Pinned "Place on your wall" — launch AR (forward to model-viewer's own trigger).
      var placeBtn = root.querySelector('[data-ar-place]');
      var arReal = root.querySelector('.tpl-ar__arreal');
      var subEl = root.querySelector('[data-ar-sub]');
      if (placeBtn) placeBtn.addEventListener('click', function(){
        if (canEscape) { openInRealBrowser(); return; }
        if (photoMode) { if (wallInput) wallInput.click(); return; }
        if (mv && mv.canActivateAR) { track('place_native'); if (arReal) arReal.click(); try { mv.activateAR(); } catch (e) {} }
        else if (subEl) { subEl.textContent = 'AR is still loading — try again in a moment.'; }
      });

      // Browsers that CANNOT launch native AR get the in-page photo wall preview
      // instead — the customer never leaves the page. Three classes land there:
      //   1. In-app webviews (Instagram/FB/…) — no Quick Look, no Chrome intent.
      //   2. iOS third-party browsers (Comet, Chrome, Firefox, Brave…) — since
      //      iOS 15.4 AR Quick Look launches ONLY from real Safari; everywhere else
      //      the generated USDZ becomes a file download (model-viewer #3421).
      //   3. Android Comet — Scene Viewer intent handoff unverified there.
      var ua = navigator.userAgent || '';
      var isInApp = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Line\/|Snapchat|Twitter|Pinterest|LinkedInApp|TikTok|musical_ly|BytedanceWebview|GSA\//i.test(ua);
      var isAndroid = /Android/i.test(ua);
      var isIOS = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
      // Real iOS Safari carries BOTH "Version/x" and "Safari/" tokens; wrappers drop
      // "Version/" (CriOS, FxiOS…) or brand the UA. Token list is belt-and-braces on
      // top of that structural check.
      var isRealSafari = isIOS && !isInApp
        && /Version\/[\d.]+/.test(ua) && /Safari\//.test(ua)
        && !/CriOS|FxiOS|EdgiOS|OPiOS|OPT\/|Comet|Perplexity|Brave|DuckDuckGo|Ddg|YaBrowser|Arc\/|Aloha|Focus\/|Ecosia/i.test(ua);
      var isBlockedAndroid = isAndroid && /Comet|Perplexity/i.test(ua);
      var noNativeAR = isInApp || (isIOS && !isRealSafari) || isBlockedAndroid;
      var qrEl = root.querySelector('.tpl-ar__qr');
      function legacyCopy(url, ok){
        var t = document.createElement('textarea');
        t.value = url; t.setAttribute('readonly', '');
        t.style.position = 'absolute'; t.style.left = '-9999px';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); ok(); } catch (e) {}
        document.body.removeChild(t);
      }
      function copyLink(btn){
        var url = qrUrl();
        var ok = function(){ var prev = btn.textContent; btn.textContent = 'Link copied ✓ — paste in Safari'; setTimeout(function(){ btn.textContent = prev; }, 2500); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(ok).catch(function(){ legacyCopy(url, ok); });
        } else { legacyCopy(url, ok); }
      }

      // ── Photo wall preview — no-native-AR browsers stay ON the page ──
      // Native camera capture (works in every webview, no permission API) →
      // wall photo backdrop → variant-matched framed print overlay, drag+pinch.
      var photoMode = noNativeAR; /* mobile-only by construction — desktop never classifies as noNativeAR */

      // ── One tap out to a real browser ──────────────────────────────────
      // True wall AR needs ARKit/ARCore plane detection, which only Quick Look
      // (Safari) and Scene Viewer (Chrome) expose. No in-webview engine can do
      // it: browser AR SDKs detect a ground plane only, so a print placed from
      // a webview floats instead of seating on the wall. So blocked browsers
      // get the 3D preview here plus ONE hop out for real AR.
      // ob=1 marks "already hopped". If we land somewhere still blocked (a
      // non-Safari default browser), we never hop again — the photo preview
      // takes over. That kills the browser-chain dead end.
      var looped = /[?&#]ob=1/.test(location.search + location.hash);
      var canEscape = noNativeAR && !looped;
      var hopFailed = false;
      var renderCtaState = function(){}; /* assigned in the photo-mode setup below */
      var escapeBrowser = isAndroid ? 'Chrome' : 'Safari';
      function escapeFailed(){
        // Some webviews (Instagram iOS) swallow the scheme/intent entirely —
        // the page never leaves, so the hop button would stay a dead end.
        if (!canEscape) return;
        canEscape = false; hopFailed = true;
        track('escape_blocked');
        renderCtaState();
      }
      function openInRealBrowser(){
        var url = qrUrl() + '&ob=1';
        track('escape_hop');
        // Still visible shortly after navigating = the hop was blocked.
        var t = setTimeout(escapeFailed, 1400);
        var cancel = function(){ clearTimeout(t); };
        window.addEventListener('pagehide', cancel, { once: true });
        document.addEventListener('visibilitychange', function onVis(){
          if (document.visibilityState === 'hidden') { cancel(); document.removeEventListener('visibilitychange', onVis); }
        });
        if (isAndroid) {
          location.href = 'intent://' + url.replace(/^https?:\/\//, '')
            + '#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url='
            + encodeURIComponent(url) + ';end';
        } else {
          // iOS: opens the DEFAULT browser (Safari for most people).
          location.href = 'x-safari-' + url;
        }
      }
      var wallEl = root.querySelector('[data-wall]');
      var wallBg = root.querySelector('[data-wall-bg]');
      var wallArt = root.querySelector('[data-wall-art]');
      var wallInput = root.querySelector('[data-wall-input]');
      var safariCopy = root.querySelector('[data-safari-copy]');
      var wallMap = {};
      try { wallMap = JSON.parse(root.querySelector('[data-wall-map]').textContent); } catch (e) {}
      var wallObjectUrl = null;
      var wallPose = { x: 0, y: 0, s: 1 };

      function wallArtSrc(){
        var fv = getOpt(frameOpt);
        var fh = fv ? fv.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-') : 'unframed';
        return wallMap[fh] || wallMap['unframed'] || wallMap['_fallback'] || '';
      }
      function syncWallArt(){
        if (!wallArt) return;
        var src = wallArtSrc();
        if (src && wallArt.getAttribute('src') !== src) wallArt.setAttribute('src', src);
      }
      function applyWallPose(){
        if (wallArt) wallArt.style.transform = 'translate(-50%, -50%) translate(' + wallPose.x + 'px, ' + wallPose.y + 'px) scale(' + wallPose.s + ')';
      }
      function enterWall(file){
        if (!wallEl || !wallBg) return;
        track('photo_mode');
        if (wallObjectUrl) { try { URL.revokeObjectURL(wallObjectUrl); } catch (e) {} }
        wallObjectUrl = URL.createObjectURL(file);
        wallBg.src = wallObjectUrl;
        syncWallArt();
        wallPose = { x: 0, y: 0, s: 1 };
        applyWallPose();
        wallEl.hidden = false;
      }
      if (wallInput) wallInput.addEventListener('change', function(){
        if (wallInput.files && wallInput.files[0]) enterWall(wallInput.files[0]);
        wallInput.value = '';
      });
      var wallRetake = root.querySelector('[data-wall-retake]');
      var wallExit = root.querySelector('[data-wall-exit]');
      if (wallRetake) wallRetake.addEventListener('click', function(){ if (wallInput) wallInput.click(); });
      if (wallExit) wallExit.addEventListener('click', function(){ if (wallEl) wallEl.hidden = true; });

      // Drag (1 pointer) + pinch (2 pointers) on the wall layer
      if (wallEl) {
        var wallPointers = {};
        var pinchStart = null;
        wallEl.addEventListener('pointerdown', function(e){
          if (e.target.closest('.tpl-ar__wall-btn')) return;
          wallPointers[e.pointerId] = { x: e.clientX, y: e.clientY };
          var ids = Object.keys(wallPointers);
          if (ids.length === 2) {
            var a = wallPointers[ids[0]], b = wallPointers[ids[1]];
            pinchStart = { d: Math.hypot(a.x - b.x, a.y - b.y), s: wallPose.s };
          }
          if (wallEl.setPointerCapture) { try { wallEl.setPointerCapture(e.pointerId); } catch (err) {} }
          e.preventDefault();
        });
        wallEl.addEventListener('pointermove', function(e){
          var p = wallPointers[e.pointerId];
          if (!p) return;
          var ids = Object.keys(wallPointers);
          if (ids.length === 1) {
            wallPose = { x: wallPose.x + (e.clientX - p.x), y: wallPose.y + (e.clientY - p.y), s: wallPose.s };
          }
          wallPointers[e.pointerId] = { x: e.clientX, y: e.clientY };
          if (ids.length === 2 && pinchStart) {
            var a2 = wallPointers[ids[0]], b2 = wallPointers[ids[1]];
            var d2 = Math.hypot(a2.x - b2.x, a2.y - b2.y);
            wallPose = { x: wallPose.x, y: wallPose.y, s: Math.min(4, Math.max(0.15, pinchStart.s * (d2 / pinchStart.d))) };
          }
          applyWallPose();
        });
        var wallPointerEnd = function(e){
          delete wallPointers[e.pointerId];
          if (Object.keys(wallPointers).length < 2) pinchStart = null;
        };
        wallEl.addEventListener('pointerup', wallPointerEnd);
        wallEl.addEventListener('pointercancel', wallPointerEnd);
      }

      if (photoMode) {
        if (qrEl) qrEl.style.display = 'none';
        if (subEl) subEl.classList.add('tpl-ar__sub--guide');
        var photoLine = root.dataset.photoLine || "Snap a photo of your wall, then drag and pinch to place the piece.";
        var escapeLine = root.dataset.escapeLine || "One tap opens this in BROWSER, where the piece lands on your wall true to size.";
        var escapeBtn = root.dataset.escapeBtn || "Open in BROWSER for AR";
        var manualLine = root.dataset.manualLine || "That didn't open automatically. Choose 'Open in external browser' from the menu above, or snap a photo of your wall instead.";
        var swapBrowser = function(s){ return s.replace(/BROWSER/g, escapeBrowser); };
        renderCtaState = function(){
          if (subEl) subEl.textContent = canEscape ? swapBrowser(escapeLine) : (hopFailed ? manualLine : photoLine);
          var btnText = canEscape ? swapBrowser(escapeBtn) : 'See it on your wall';
          if (placeBtn) placeBtn.childNodes.forEach(function(n){
            if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ' ' + btnText + ' ';
          });
        };
        renderCtaState();
        if (safariCopy) {
          safariCopy.hidden = false;
          safariCopy.addEventListener('click', function(){ copyLink(safariCopy); });
        }
      }
      // Desktop handoff — a real, scannable QR that deep-links this exact variant
      // with ?ar=1 so the phone lands straight in the AR sheet. Replaces the old
      // decorative placeholder + "open on your phone" prompt.
      var qrBox = root.querySelector('[data-ar-qr]');
      var qrMedia = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
      var lastQrUrl = '';
      function qrUrl(){
        var id = currentId();
        var path = root.dataset.productPath || location.pathname;
        return location.origin + path + (id ? '?variant=' + id + '&ar=1' : '?ar=1');
      }
      function ensureQR(cb){
        if (window.qrcode) return cb();
        var s = document.getElementById('tpl-qr-script');
        if (!s) {
          s = document.createElement('script');
          s.id = 'tpl-qr-script';
          s.src = root.dataset.qrSrc;
          document.head.appendChild(s);
        }
        s.addEventListener('load', function(){ cb(); }, { once: true });
      }
      function renderQR(){
        // Only where the QR block is actually shown (fine-pointer devices, real browser)
        if (!qrBox || noNativeAR || !qrMedia || !qrMedia.matches) return;
        var url = qrUrl();
        if (url === lastQrUrl) return;
        ensureQR(function(){
          try {
            var qr = window.qrcode(0, 'M');
            qr.addData(url);
            qr.make();
            qrBox.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 8, scalable: true });
            lastQrUrl = url;
          } catch (e) { /* QR is progressive enhancement — the copy line still guides */ }
        });
      }
      function markNoAR(){
        // Desktop (no AR runtime): the QR handoff becomes the CTA; CSS drops the dead button
        if (qrMedia && qrMedia.matches && !noNativeAR) root.classList.add('is-noar');
      }
      function ensureMV(cb){
        // Lazy-load the self-hosted model-viewer only when the modal first opens
        // (keeps 935KB off the initial PDP). Self-hosted = works in preview + live,
        // no external CDN dependency.
        if (window.customElements && customElements.get('model-viewer')) return cb();
        if (!document.getElementById('tpl-mv-script')) {
          var s = document.createElement('script');
          s.id = 'tpl-mv-script';
          s.type = 'module';
          s.src = root.dataset.mvSrc;
          document.head.appendChild(s);
        }
        if (window.customElements && customElements.whenDefined) {
          customElements.whenDefined('model-viewer').then(cb);
        } else { cb(); }
      }
      function open(){
        modal.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        track('open');
        syncAtc();
        renderQR();
        ensureMV(function(){
          update();
          setTimeout(update, 120);
          /* canActivateAR resolves right after upgrade; belt-and-braces re-check on 'load' above */
          setTimeout(function(){ if (mv && mv.canActivateAR === false) markNoAR(); }, 150);
        });
      }
      function close(){
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
      var inlineOpen = root.querySelector('[data-ar-open]');
      if (inlineOpen) inlineOpen.addEventListener('click', open);
      root.querySelectorAll('[data-ar-close]').forEach(function(b){ b.addEventListener('click', close); });
      // Wire any trigger buttons elsewhere on the page (e.g. in the buy area) and reveal them.
      document.querySelectorAll('[data-ar-trigger]').forEach(function(b){ b.hidden = false; b.addEventListener('click', open); });
      window.tplAROpen = open;

      // Inject ONE "See it on your wall" pill anchored to the gallery VIEWPORT (the
      // media wrapper), so it stays put while the images swipe underneath (sticky),
      // positioned over the visible image's bottom-right. Mobile only (desktop uses
      // the bottom action bar). Dotted round-dot border per the brand system.
      (function injectGalleryPill(){
        // La Siesta pages have no Dawn gallery: anchor to their own gallery frame (2026-10-27).
        var host = document.querySelector('.product__media-wrapper') || document.querySelector('media-gallery') ||
          document.querySelector('[data-tpl-mat-gallery] .tpl-mp__inner');
        if (!host || document.querySelector('.tpl-ar-gallery-pill')) return;
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        var label = root.dataset.pillLabel || 'See it on your wall';
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'tpl-ar-gallery-pill';
        pill.innerHTML =
          '<svg class="tpl-ar-cube" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2 21 7v10l-9 5-9-5V7l9-5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M3 7l9 5 9-5M12 12v10" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>' +
          '<span>' + label + '</span>';
        pill.addEventListener('click', open);
        host.appendChild(pill);
        // La Siesta gallery (owner 2026-11-03): a compact pill at the slide's bottom-left,
        // hidden on the Views slide, whose bottom row of side views it would cover.
        var lsGallery = host.closest('[data-tpl-mat-gallery]');
        if (lsGallery) {
          pill.classList.add('tpl-ar-gallery-pill--ls');
          var lsTrack = lsGallery.querySelector('[data-mg-track]');
          var lsSlides = lsTrack ? Array.prototype.slice.call(lsTrack.querySelectorAll('[data-mg-slide]')) : [];
          var HIDE_ON = { 'its-layers-and-three-side-views': true };
          var lsPending = false;
          var onSlide = function(){
            lsPending = false;
            var best = null, bd = Infinity;
            lsSlides.forEach(function(sl){ var d = Math.abs(sl.offsetLeft - lsTrack.scrollLeft); if (d < bd) { bd = d; best = sl; } });
            var hide = !!(best && HIDE_ON[best.getAttribute('data-mg-slot')]);
            pill.classList.toggle('is-hidden', hide);
            pill.tabIndex = hide ? -1 : 0;
          };
          if (lsTrack) {
            lsTrack.addEventListener('scroll', function(){ if (!lsPending) { lsPending = true; requestAnimationFrame(onSlide); } }, { passive: true });
            onSlide();
          }
        }
        // Keep the pill over the visible image's bottom-right (image is letterboxed
        // inside the wrapper, which also includes the pager strip below it).
        function align(){
          var img = host.querySelector('.product__media-item img') || host.querySelector('img');
          if (!img) return;
          var hb = host.getBoundingClientRect(), ib = img.getBoundingClientRect();
          if (!ib.width) return;
          if (lsGallery) {
            pill.style.right = 'auto';
            pill.style.left = Math.round(Math.max(12, (ib.left - hb.left) + 12)) + 'px';
            pill.style.bottom = Math.round(Math.max(12, (hb.bottom - ib.bottom) + 12)) + 'px';
            return;
          }
          pill.style.right = Math.round(Math.max(14, (hb.right - ib.right) + 14)) + 'px';
          pill.style.bottom = Math.round(Math.max(14, (hb.bottom - ib.bottom) + 14)) + 'px';
        }
        requestAnimationFrame(align);
        setTimeout(align, 500);
        window.addEventListener('resize', align);
      })();
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
      document.addEventListener('change', function(e){
        if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) setTimeout(update, 60);
      });

      // QR deep link: page opened from a desktop scan (?ar=1 / #ar) — land straight
      // in the AR sheet with the scanned variant preselected by Shopify.
      if (/[?&]ar=1(?:&|$)/.test(location.search) || location.hash === '#ar') {
        setTimeout(open, 250);
      }
    }
    document.querySelectorAll('.tpl-ar[id^="tpl-ar-"]').forEach(bind);
    })();
